import { httpGet } from '../utils'

export default {
  getList (cb, { page, perPage }) {
    httpGet(`/api/project?page=${page}&per_page=${perPage}&order_by=id`, cb)
  },
  getOne (cb, id) {
    httpGet(`/api/project/${id}`, cb)
  },
  getFeedbackList (cb, { id, page, perPage, searchName }) {
    let url = `/api/project/${id}/donate?page=${page}&per_page=${perPage}&order_by=id`
    if (searchName) {
      url += `&name=${searchName}`
    }
    httpGet(url, cb)
  },
  getFeedbackDetail (cb, { contactId, projectId, donateId }) {
    if (contactId) {
      httpGet(`/api/contact/${contactId}/donate/${donateId}`, cb)
    } else if (projectId) {
      httpGet(`/api/project/${projectId}/donate/${donateId}`, cb)
    }
  },
  getShare (cb, id) {
    httpGet(`/api/share/project/${id}`, cb)
  }
}



// WEBPACK FOOTER //
// ./src/api/lxm/cf.js